import { render, staticRenderFns } from "./edit-expert-modal.vue?vue&type=template&id=34fd956e&"
import script from "./edit-expert-modal.vue?vue&type=script&lang=js&"
export * from "./edit-expert-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports